"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.withKeys = exports.withProps = exports.P = exports.share = void 0;

var share = function share(a) {
  var b = a.props,
      c = void 0 === b ? {} : b;
  return c;
};

exports.share = share;

var P = function P() {};

exports.P = P;

var withProps = function withProps() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [{}];
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return a.map(function (a) {
      return a.props = b, a;
    });
  };
};

exports.withProps = withProps;

var withKeys = function withKeys() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [{}];
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : "p-xxxxx";
    return a.map(function (a) {
      return a.key = b, a;
    });
  };
};

exports.withKeys = withKeys;